module.exports = __webpack_public_path__ + "img/banner1.da8662ae.jpg";